import { render, staticRenderFns } from "./ComponentAdder.vue?vue&type=template&id=22817ae4&scoped=true&"
import script from "./ComponentAdder.vue?vue&type=script&lang=js&"
export * from "./ComponentAdder.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAdder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ComponentAdder.vue?vue&type=style&index=1&id=22817ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22817ae4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/dealerdraft/dealerdraft/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VSelect,VTextField})
